<script lang="ts" setup>
import { ref } from 'vue';

const { active } = defineProps<{ active: boolean }>();

defineEmits<{
	click: [];
}>();

const hovering = ref(false);
const focusing = ref(false);

function onFocus(event: FocusEvent) {
	const element = event.target;
	focusing.value = element instanceof HTMLElement && element.matches(':focus-visible');
}

function onBlur() {
	focusing.value = false;
}
</script>

<template>
	<DButton
		size="xs"
		variant="ghost"
		color="neutral"
		:pressed="active"
		class="rounded-sm p-0.5"
		@click="$emit('click')"
		@pointerenter="hovering = true"
		@pointerleave="hovering = false"
		@focus="onFocus"
		@blur="onBlur"
	>
		<template #leading>
			<AiSparkle :animate="hovering || focusing" />
		</template>
	</DButton>
</template>
